import React from "react"
import Fixtures from "./components/WorldCupFixtures"
import Sports from "./components/Sports"
import Navbar from './components/Navbar'
import Footer from './components/Footer'


export default function Home({principal,setPrincipal}) {
  return (
    <div>
      <header
        className="sticky top-0 z-50" >
        < Navbar principal={principal} setPrincipal={setPrincipal}/>
      </header>
      <div>
        <Sports/>
        <Fixtures/>
      </div>
      <footer className="fixed bottom-0 w-full z-50">
        < Footer />
      </footer>
    </div>
    
  );
}


